/**
 * App
 */

// React
import React, {FC} from 'react';

// Router
import { Router, Switch, Route} from 'react-router-dom';
import Refree from './routes';

// Components
import Auth from './components/Auth';
import * as Sentry from '@sentry/react';

// UI
import {Container} from '@material-ui/core';
import Root from './pages/root';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import history from './utils/history';
import { Helmet } from 'react-helmet';
const env = process.env.REACT_APP_ENVIROMENT;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      '& .MuiContainer-maxWidthXl': {
        maxWidth: '100%',
      },
    },
  })
);

const SentryRoute = Sentry.withSentryRouting(Route);
Sentry.init({
  dsn: "https://6e41a0b0b6cb02b7fe297fa8e50b033c@o4506965113110528.ingest.us.sentry.io/4506998418571264",
  integrations: [
    Sentry.reactRouterV5BrowserTracingIntegration({ history }),
    // or
    Sentry.reactRouterV4BrowserTracingIntegration({ history }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

const App: FC = (props: object) => {
  const classes = useStyles();
  return (
    <Router history={history}>
      <Switch>
        <SentryRoute exact path="/" component={Root} />
        <Auth>
          <div className={classes.root}>
            <Refree />
          </div>
          <Helmet>
            <script type="text/javascript">
              {(function (c, l, a, r, i, t, y) { c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }; t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i; y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y); })(window, document, "clarity", "script", "lmlslsmrmo")}
            </script>
          </Helmet>
        </Auth>
      </Switch>
    </Router>
  );
};

export default App;
